const excludedLinks = ['accessibilityStatement'];

export const checkForExcludedLink = (key: string) => {
  if (!key) return false;

  return excludedLinks.includes(key);
};
